<template>
    <div class="container">
        <div class="title">
            <img src="../../src/assets/images/achieve/logo.png" alt="" />
        </div>
        <div class="headerBac"></div>
        <div class="contentBox dzyjbox">
            <div class="dzyjItem">
                <div class="title">{{ obj.pName }}：{{ obj.fName }}</div>
                <div class="time">
                    发布时间：{{ obj.showTime }}&#x3000;阅读量：{{ obj.readCount }}
                </div>
            </div>

            <div class="mainBox">
                <div class="textBox" v-html="obj.details"></div>
            </div>
        </div>
        <div class="footBac"></div>

    </div>
</template>
<script>
import API from "../../apis/index";
export default {
    name: "AchieveDetail",
    components: {
        // CarouselCopy,
    },
    data() {
        return {
            obj: {},
        };
    },
    mounted() {
        const currentRouter = {
            name: "学术成就详情",
            path: "/achieveDetail",
        };

        localStorage.setItem("currentRouter", JSON.stringify(currentRouter));
    },
    created() {
    this.params = JSON.parse(this.$route.query.item)
    this.init()
  },
  methods: {
    init() {
      this.$http.get(`${API.getForum}?type=6&fId=${this.params.fId}`).then(res => {
        console.log(res.data.data)
        this.obj = res.data.data
        
      })
    }
  }
};
</script>
<style scoped>
.container {
    width: 1000px;
    padding: 0 0 90px;
}
.headerBac{
    width: 100%;
    height: 60px;
    background: url("../../src/assets/images/headerBac.png") no-repeat;
    background-size: 100% 100%;
    margin-top: 20px;

}
.footBac{
    width: 100%;
    height: 60px;
    background: url("../../src/assets/images/footBac.png") no-repeat;
    background-size: 100% 100%;

}
.contentBox {
    width: 100%;
    /* height: 1098px; */
    background: url("../../src/assets/images/bodyBac.png") no-repeat;
    background-size: 100% 100%;
}

.dzyjbox {
    display: flex;
    padding: 37px 45px 53px;
    flex-direction: column;

}

.dzyjItem {
    width: 100%;
    height: 75px;
    border-bottom: 1px solid #eae0d5;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #391603;
    line-height: 22px;
    margin-bottom: 10px;
    cursor: pointer;
}

.time {
    font-size: 12px;
    font-family: PingFangTC-Regular, PingFangTC;
    font-weight: 400;
    color: #391603;
    line-height: 17px;
}

.textBox {
    text-align: justify;

    margin: 30px auto;
}

.mainBox {}
</style>